import { VIEW_ID, type ViewsFactory } from '@commons/pagebuilder/views';
import InsightsView from '@commons/pagebuilder/views/Insights';

import MembersView from './Members';

/**
 * Enum of all available view types for AiiA.
 *
 * Makes it easier to read and edit the ids.
 */

export enum AIIA_VIEW_TYPE {
  Members = 'members',
  Insights = VIEW_ID.Insights,
}

/**
 * Factory of all available views for AiiA.
 */

export const aiiaViews: ViewsFactory = {
  [AIIA_VIEW_TYPE.Members]: MembersView,
  [AIIA_VIEW_TYPE.Insights]: InsightsView,
};
